import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=793a0c6a&scoped=true&"
import script from "./TaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793a0c6a",
  null
  
)

export default component.exports